import React, { useState, useEffect, memo, useMemo } from 'react';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';

const { cor_tipos_situacao } = require('../../config.json')

export default function OutageCounters() {

    const qtd_list_chamados = ['opa']

    const styleCardsContent = {
        marginTop: -8,
        padding: 0,
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 100,
        maxHeight: 100
    }

    const style_image_loading = {
        width: 100,
        marginLeft: 0
    }


    return (
        <div className='card justify-evenly' style={{ width: '100%', flexDirection: 'row', padding: 10, alignItems: 'flex-start' }}>
            <Card className="card_contador_chamados"
                style={{
                    // backgroundColor: cor_tipos_situacao['novo'],
                    borderTop: `8px solid ${cor_tipos_situacao['novo']}`,
                    borderBottom: `8px solid ${cor_tipos_situacao['novo']}`,
                    borderRadius: '40px 0px 30px 0px'

                }}
                onClick={() => {

                }}>
                <CardContent style={styleCardsContent}>
                    <div className='flex justify-center items-center' style={{ width: '100%', textAlign: 'center', fontSize: '3em' }}>
                        {qtd_list_chamados.length === 0 ? <img style={style_image_loading} src="https://apisgi.intecsolutions.com.br/uploads/loading.webp" /> : 0}
                    </div>
                    <div style={{ width: '100%', textAlign: 'center', fontSize: '1.3em' }}>Inativos</div>
                </CardContent>
            </Card>


            <Card className="card_contador_chamados"
                style={{
                    // backgroundColor: cor_tipos_situacao['em_tratativa'],
                    borderTop: `8px solid ${cor_tipos_situacao['em_tratativa']}`,
                    borderBottom: `8px solid ${cor_tipos_situacao['em_tratativa']}`,
                    borderRadius: '40px 0px 30px 0px'
                }}
                onClick={() => {

                }}>
                <CardContent style={styleCardsContent}>
                    <div className='flex justify-center items-center' style={{ width: '100%', textAlign: 'center', fontSize: '3em' }}>
                        {qtd_list_chamados.length === 0 ? <img style={style_image_loading} src="https://apisgi.intecsolutions.com.br/uploads/loading.webp" /> : 0}
                    </div>
                    <div style={{ width: '100%', textAlign: 'center', fontSize: '1.3em' }}>Em tratativa</div>
                </CardContent>
            </Card>


            <Card className="card_contador_chamados"
                style={{
                    // backgroundColor: cor_tipos_situacao['em_execucao'],
                    borderTop: `8px solid ${cor_tipos_situacao['em_execucao']}`,
                    borderBottom: `8px solid ${cor_tipos_situacao['em_execucao']}`,
                    borderRadius: '40px 0px 30px 0px'
                }}
                onClick={() => {

                }}>
                <CardContent style={styleCardsContent}>
                    <div className='flex justify-center items-center' style={{ width: '100%', textAlign: 'center', fontSize: '3em' }}>
                        {qtd_list_chamados.length === 0 ? <img style={style_image_loading} src="https://apisgi.intecsolutions.com.br/uploads/loading.webp" /> : 0}
                    </div>
                    <div style={{ width: '100%', textAlign: 'center', fontSize: '1.3em' }}>Agendados</div>
                </CardContent>
            </Card>


            <Card className="card_contador_chamados"
                style={{
                    // backgroundColor: cor_tipos_situacao['pendente_cliente'],
                    borderTop: `8px solid ${cor_tipos_situacao['pendente_cliente']}`,
                    borderBottom: `8px solid ${cor_tipos_situacao['pendente_cliente']}`,
                    borderRadius: '40px 0px 30px 0px'
                }}
                onClick={() => {

                }}>
                <CardContent style={styleCardsContent}>
                    <div className='flex justify-center items-center' style={{ width: '100%', textAlign: 'center', fontSize: '3em' }}>
                        {qtd_list_chamados.length === 0 ? <img style={style_image_loading} src="https://apisgi.intecsolutions.com.br/uploads/loading.webp" /> : 0}
                    </div>
                    <div style={{ width: '100%', textAlign: 'center', fontSize: '1.3em' }}>Pendentes</div>
                </CardContent>
            </Card>


            <Card className="card_contador_chamados"
                style={{
                    // backgroundColor: cor_tipos_situacao['janela_agendada'],
                    borderTop: `8px solid ${cor_tipos_situacao['janela_agendada']}`,
                    borderBottom: `8px solid ${cor_tipos_situacao['janela_agendada']}`,
                    borderRadius: '40px 0px 30px 0px'
                }}
                onClick={() => {

                }}>
                <CardContent style={styleCardsContent}>
                    <div className='flex justify-center items-center' style={{ width: '100%', textAlign: 'center', fontSize: '3em' }}>
                        {qtd_list_chamados.length === 0 ? <img style={style_image_loading} src="https://apisgi.intecsolutions.com.br/uploads/loading.webp" /> : 0}
                    </div>
                    <div style={{ width: '100%', textAlign: 'center', fontSize: '1.3em' }}>Finalizados</div>
                </CardContent>
            </Card>
        </div>
    )
}